import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {switchMap} from 'rxjs/internal/operators';
import {catchError, map} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {error} from '../actions/toasts';
import {ArrayResponse} from '../models/array-response';
import { Office} from '../models/culture';
import {SendBackResult} from '../models/send-back-result';
import {BaseEffect} from './base.effect';
import {OfficesService} from '../services/offices.service';
import {LoadOfficesFailAction, LoadOfficesSuccessAction, officesActionTypes} from '../actions/offices';
import {L10nTranslationService} from 'angular-l10n';
import {ApiCacheService} from '../services/cache.service';
import {of} from 'rxjs';

@Injectable()
export class OfficesEffect extends BaseEffect {

  load$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(officesActionTypes.LOAD),
      debug('Load Office action received;'),
      switchMap(() => {
        const cacheKey = 'offices';
        const cached = this.apiCacheService.get<Office[]>(cacheKey);

        if (cached) {
          return of(new LoadOfficesSuccessAction(cached));
        }

        return this.officesService.getList().pipe(
          map((payload: SendBackResult<ArrayResponse<Office>>) => {
            const offices = payload.data.array;
            this.apiCacheService.set(cacheKey, offices);
            return new LoadOfficesSuccessAction(offices);
          }),
          catchError(res => this.catchResponseError(res))
        );
      })
    );
  });


  loadFail$ = createEffect(() => { return this.actions$.pipe(ofType(officesActionTypes.LOAD_FAIL),
    debug('Load offices fail action received.'),
    map((err: LoadOfficesFailAction ) =>
      error(this.translation.translate('OFFICES_LOAD_ERROR') + err.payload, this.translation.translate('TOAST_ERROR_TITLE'))
    ))
  });

  constructor(private actions$: Actions,
              private apiCacheService: ApiCacheService,
              private translation: L10nTranslationService,
              private officesService: OfficesService,
              router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadOfficesFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadOfficesFailAction(response['error'].message);
  }
}
